/* =====================================================================
   product-testi.js — Testituotesivun logiikka
   1) Toimitus-countdown: cutoff data-cutoff-hour (11 tai 14), Europe/Helsinki.
   2) Osamaksu: minirivi + modaali (yritys + kuluttaja sliderit).
      base seuraa ALV-togglea (window.VAT). Erä = base_eur * factor.
   Ladataan vain main-product-testi -sektiossa.
   ===================================================================== */
(function () {
  'use strict';

  var NBSP = '\u00a0';

  /* ---------- Rahaformaatti (FI-tyyli, sama kuin vat-toggle.js) ---------- */
  function fmtEur(eur, currency) {
    var n = Math.abs(Number(eur) || 0);
    var v = n.toFixed(2).split('.');
    var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
    return whole + ',' + v[1] + NBSP + '\u20ac';
  }

  /* ---------- ALV-tila teemasta ---------- */
  function baseEur(inclCents, vatRate, forceExcluded) {
    // Yritysrahoitus on aina ALV 0 → forceExcluded pakottaa alvittoman kannan.
    // Kuluttaja seuraa headerin ALV-togglea (window.VAT).
    var excluded = forceExcluded || (window.VAT && window.VAT.isExcluded ? window.VAT.isExcluded() : false);
    var cents = excluded ? Math.round(inclCents / vatRate) : inclCents;
    return cents / 100;
  }

  /* =====================================================================
     1) TOIMITUS-COUNTDOWN
     ===================================================================== */
  function initCountdown(el) {
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoffHour)) cutoffHour = 11;
    var timerEl = el.querySelector('[data-ship-timer]');

    // Nykyhetki Europe/Helsinki -vyöhykkeellä (riippumaton selaimen kellosta).
    function helsinkiNow() {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Helsinki',
        weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      var wdMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return {
        dow: wdMap[o.weekday],
        h: parseInt(o.hour, 10) % 24,
        m: parseInt(o.minute, 10),
        s: parseInt(o.second, 10)
      };
    }

    function tick() {
      // Varastolukko: jos valittu variantti ei ole aidosti varastossa, ei lupausta.
      if (el.getAttribute('data-ship-oos') === '1') { el.hidden = true; return; }
      var now = helsinkiNow();
      var isWeekday = now.dow >= 1 && now.dow <= 5;
      var secsNow = now.h * 3600 + now.m * 60 + now.s;
      // Luetaan joka tikillä → variantin vaihto (paino) päivittää cutoffin
      var ch = parseInt(el.getAttribute('data-cutoff-hour'), 10);
      var cutoffSecs = (isNaN(ch) ? cutoffHour : ch) * 3600;

      if (isWeekday && secsNow < cutoffSecs) {
        var remain = cutoffSecs - secsNow;
        var hh = Math.floor(remain / 3600);
        var mm = Math.floor((remain % 3600) / 60);
        var ss = remain % 60;
        var txt;
        if (hh > 0) {
          txt = hh + ' h ' + String(mm).padStart(2, '0') + ' min';
        } else if (mm > 0) {
          txt = mm + ' min ' + String(ss).padStart(2, '0') + ' s';
        } else {
          txt = ss + ' s';
        }
        if (timerEl) timerEl.textContent = txt;
        el.hidden = false;
      } else {
        // Cutoff mennyt tai viikonloppu → piilotetaan (ei lupausta tästä päivästä).
        el.hidden = true;
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  /* =====================================================================
     2) OSAMAKSU
     ===================================================================== */
  function parseFactors(str) {
    // "36:0.0312,48:0.0236,..." → [{months,factor}]
    return String(str || '').split(',').map(function (pair) {
      var kv = pair.split(':');
      return { months: parseInt(kv[0], 10), factor: parseFloat(kv[1]) };
    }).filter(function (x) { return isFinite(x.months) && isFinite(x.factor); });
  }

  function initFinance(mini) {
    var modal = document.querySelector('[data-fin-modal]');
    var priceCents = parseInt(mini.getAttribute('data-fin-price'), 10);
    var vatRate = parseFloat(mini.getAttribute('data-vat-rate')) || 1.255;
    var handlingFactor = parseFloat(mini.getAttribute('data-handling-factor')) || 0.0028;
    var handlingMax = parseFloat(mini.getAttribute('data-handling-max')) || 12.5;
    var currency = mini.getAttribute('data-currency') || 'EUR';

    var bizSteps = parseFactors(mini.getAttribute('data-biz-factors'));
    var conSteps = parseFactors(mini.getAttribute('data-con-factors'));
    var conKorot = String(mini.getAttribute('data-con-korot') || '').split('|'); // per indeksi
    var bizMiniIdx = parseInt(mini.getAttribute('data-biz-default-idx'), 10) || 0;
    var conMiniIdx = parseInt(mini.getAttribute('data-con-default-idx'), 10) || 0;

    var tPerMonth = mini.getAttribute('data-t-permonth') || '/ kk';
    var tFree = mini.getAttribute('data-t-free') || '';
    var tHandling = mini.getAttribute('data-t-handling') || 'käsittely';
    var tInterest = mini.getAttribute('data-t-interest') || 'korko';

    var miniAmount = mini.querySelector('[data-fin-mini-amount]');
    var miniMonths = mini.querySelector('[data-fin-mini-months]');

    var bizSlider = modal && modal.querySelector('[data-fin-biz-slider]');
    var bizMonths = modal && modal.querySelector('[data-fin-biz-months]');
    var bizResult = modal && modal.querySelector('[data-fin-biz-result]');
    var conSlider = modal && modal.querySelector('[data-fin-con-slider]');
    var conLabel = modal && modal.querySelector('[data-fin-con-label]');
    var conResult = modal && modal.querySelector('[data-fin-con-result]');
    var conSub = modal && modal.querySelector('[data-fin-con-sub]');
    var conUnit = modal && modal.querySelector('.sp-finance__result-unit');

    var mode = 'yritys'; // aktiivinen tila (minirivi + modaali synkassa)

    function update() {
      var baseBiz = baseEur(priceCents, vatRate, true);   // yritys: aina ALV 0
      var baseCon = priceCents / 100;                     // kuluttaja: aina sis. ALV
      if (!isFinite(baseBiz) || baseBiz <= 0) { mini.hidden = true; return; }
      mini.hidden = false;

      var fee = Math.min(baseCon * handlingFactor, handlingMax);

      /* Minirivi */
      if (mode === 'yritys' && bizSteps[bizMiniIdx]) {
        if (miniAmount) miniAmount.textContent = fmtEur(baseBiz * bizSteps[bizMiniIdx].factor, currency);
        if (miniMonths) miniMonths.textContent = bizSteps[bizMiniIdx].months;
      } else if (mode === 'kuluttaja' && conSteps[conMiniIdx]) {
        if (miniAmount) miniAmount.textContent = fmtEur(baseCon * conSteps[conMiniIdx].factor, currency);
        if (miniMonths) miniMonths.textContent = conSteps[conMiniIdx].months;
      }

      /* Yritys-slider */
      if (bizSlider && bizSteps.length) {
        var yi = parseInt(bizSlider.value, 10);
        if (bizSteps[yi]) {
          if (bizResult) bizResult.textContent = fmtEur(baseBiz * bizSteps[yi].factor, currency);
          if (bizMonths) bizMonths.textContent = bizSteps[yi].months;
        }
      }

      /* Kuluttaja-slider */
      if (conSlider && conSteps.length) {
        var ki = parseInt(conSlider.value, 10);
        var step = conSteps[ki];
        if (step) {
          if (step.months === 0) {
            if (conResult) conResult.textContent = '0' + NBSP + '\u20ac';
            if (conUnit) conUnit.textContent = '';
            if (conSub) conSub.textContent = tFree;
            if (conLabel) conLabel.textContent = '30\u201360 pv';
          } else {
            if (conResult) conResult.textContent = fmtEur(baseCon * step.factor, currency);
            var korko = conKorot[ki] || '';
            if (conUnit) conUnit.textContent = tPerMonth;
            if (conSub) conSub.textContent = tHandling + ' ' + fmtEur(fee, currency) +
              NBSP + '\u00b7 ' + tInterest + ' ' + korko;
            if (conLabel) conLabel.textContent = step.months + ' kk';
          }
        }
      }
    }

    /* Tila-vaihto (minirivi + modaali napit) */
    function setMode(next) {
      mode = next;
      document.querySelectorAll('[data-fin]').forEach(function (btn) {
        var on = btn.getAttribute('data-fin') === next;
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        if (btn.className.indexOf('sp-finance-mini__switch-btn') > -1) {
          btn.classList.toggle('sp-finance-mini__switch-btn--active', on);
        } else if (btn.className.indexOf('sp-finance__switch-btn') > -1) {
          btn.classList.toggle('sp-finance__switch-btn--active', on);
        }
      });
      if (modal) {
        modal.querySelectorAll('[data-fin-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-fin-panel') !== next;
        });
        moveSlider();
      }
      update();
    }

    /* Modaalin liukuva korostus */
    function moveSlider() {
      if (!modal) return;
      var sw = modal.querySelector('.sp-finance__switch');
      var slider = sw && sw.querySelector('.sp-finance__switch-slider');
      var active = sw && sw.querySelector('.sp-finance__switch-btn--active');
      if (slider && active) {
        slider.style.left = active.offsetLeft + 'px';
        slider.style.width = active.offsetWidth + 'px';
      }
    }

    document.addEventListener('click', function (e) {
      var finBtn = e.target.closest('[data-fin]');
      if (finBtn) { setMode(finBtn.getAttribute('data-fin')); return; }

      if (e.target.closest('[data-fin-open]')) {
        if (!modal) return;
        modal.hidden = false;
        document.body.classList.add('sp-finance-modal-open');
        requestAnimationFrame(moveSlider);
        return;
      }
      if (e.target.closest('[data-fin-close]')) {
        if (!modal) return;
        modal.hidden = true;
        document.body.classList.remove('sp-finance-modal-open');
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) {
        modal.hidden = true;
        document.body.classList.remove('sp-finance-modal-open');
      }
    });

    if (bizSlider) bizSlider.addEventListener('input', update);
    if (conSlider) conSlider.addEventListener('input', update);

    // ALV-toggle vaihtaa base → päivitä erät. vat-toggle.js ei lähetä omaa
    // eventtiä, joten kuunnellaan samaa kytkintä (klik) mikrotaskin jälkeen.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-vat-switch]')) setTimeout(update, 0);
    });
    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-vat-switch]')) setTimeout(update, 0);
    });

    setMode('yritys');
  }

  /* ---------- Init ---------- */
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    document.querySelectorAll('[data-ship-countdown]').forEach(initCountdown);
    var mini = document.querySelector('[data-fin-mini]');
    if (mini) initFinance(mini);
  });
})();